
const Definition = {

    id: "panteran",
    plan_level: 2,
    name: "Panteran",
    path: "member/panteran/components/Landing",
    preview_image: "https://images.imagerenderer.com/images/artworkimages/mediumlarge/1/history-of-pink-abstract-art-by-linda-woods-linda-woods.jpg",
    colors: {
        background: "#05050a",
        background_alt: "#08080f",
        background_raised: "#0c0c15",
        surface: "#0f0f1c",
        surface_alt: "#161625",
        header_background: "#05050ad1",
        text: "#ffffff",
        text_soft: "#c5c8d8",
        text_muted: "rgba(197,200,216,0.45)",
        primary: "#f0055f",
        primary_light: "#ff2075",
        secondary: "#e2b046",
        accent: "#6aaddf",
        success: "#22C55E",
        danger: "#EF4444"
    }

};

export default Definition;
